import { render, staticRenderFns } from "./BookWidgetView.vue?vue&type=template&id=4c8bc004&"
import script from "./BookWidgetView.vue?vue&type=script&lang=js&"
export * from "./BookWidgetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports